export class ErrorHandler {
   static swallowModalCloseErrors(error: any): void {
      // "Errors" from user clicking outside/pressing escape to exit modals
      if (error !== undefined && error !== 'backdrop click' && error !== 'escape key press') {
         throw new Error(error);
      }
   }
}
